module.exports = __webpack_public_path__ + "img/BAequipmentManage.57135453.svg";